const getImgSize = src => {
    return new Promise(resolve => {
        if (!src) resolve({ imgLoadError: true });
        const img = new Image();
        img.src = src;
        img.onload = function onload() {
            resolve({
                width: this.width,
                height: this.height
            });
        };
        img.onerror = () => {
            resolve({ imgLoadError: true });
        };
    });
};

export default getImgSize;
